import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR, setUniform } from "./webgl0.js";

function Scene() {
this.vertexShader = `#version 300 es
in vec3 aPos;
out vec3 vPos;

void main() {
  gl_Position = vec4(aPos, 1.0);
  vPos = aPos;
}`;

this.fragmentShader = `#version 300 es
precision mediump float;

in vec3 vPos;
out vec4 fragColor;

uniform float uTime;

void main() {
  float radius = 2.0 + 1.5 * sin(uTime * 1.0);
  
  vec3 scaledPos = vPos / radius;

  float z = sqrt(max(0.0, 1.0 - dot(scaledPos.xy, scaledPos.xy)));
  vec3 p = vec3(vPos.xy, z);

  vec3 lightSource = vec3(1.0, 1.0, 1.5 * cos(uTime) + 1.5);

  float diffused = 0.0;

  if(p.z > 0.0) {
      float cosineValue = dot(p, lightSource);
      diffused = 0.5 * max(0.0, cosineValue) / radius;
  }

  fragColor = vec4(1.0, diffused * 0.5 + cos(uTime) * 0.5, diffused + sin(uTime) * 0.5, 1.0);
}
`;

  let startTime = Date.now() / 1000;

  this.update = () => {
    setUniform('1f', 'uTime', Date.now() / 1000 - startTime);
  };
}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);
  const [scene, setScene] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);
    setScene(newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore in non-HMR env */ }
    return () => { try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style = { { display: "flex", justifyContent: "center", gap : "16px" } }>
        <canvas ref={canvasRef} width={400} height={400} style={{ width : "400px", height : "400px", display: "block", margin: "0 auto", background: "#f6f6f6" }} />
        <pre>{ scene?.fragmentShader }</pre>
    </div>
  );
}
